import { Link } from "react-router-dom";
import { servicesData } from "../../../mocks/home-data";
import FadeIn from "../../../components/base/FadeIn";

export default function Services() {
  return (
    <section className="py-20 md:py-28 bg-cream-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <FadeIn>
            <div className="text-center mb-16 md:mb-20">
              <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
                Neler Sunuyoruz
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Kapsamlı Veteriner
                <br />
                <span className="font-serif italic text-primary-700">Hizmetleri</span>
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                Modern teknoloji ve özenli ekibimizle dostlarınıza en iyi bakımı sunuyoruz.
                Her tür için özel tedavi programları.
              </p>
            </div>
          </FadeIn>

          {/* Service Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {servicesData.map((service, index) => (
              <FadeIn key={service.id} delay={index * 0.15}>
                <div
                  className={`${service.bgColor} rounded-2xl p-7 md:p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 group cursor-pointer h-full`}
                >
                  <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-6 group-hover:bg-primary-200 transition-colors duration-300">
                    <i className={`${service.icon} text-3xl text-primary-700 w-8 h-8 flex items-center justify-center`} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-800 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-5 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2.5">
                    {service.items.slice(0, 5).map((item) => (
                      <li
                        key={item}
                        className={`flex items-start gap-2.5 text-sm ${
                          item === service.highlight
                            ? "font-semibold text-primary-800"
                            : "text-gray-600"
                        }`}
                      >
                        <i className="ri-check-line w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0 bg-primary-50 rounded-full text-xs" />
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 pt-5 border-t border-gray-200/50">
                    <Link
                      to="/hizmetler"
                      className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors group/link"
                    >
                      Detaylı Bilgi
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.3}>
            <div className="mt-14 text-center">
              <Link
                to="/hizmetler"
                className="inline-flex items-center gap-2 px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Tüm Hizmetleri Gör
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}